import { createContext, useCallback, useContext, useState } from 'react';
import { fetchJson, responseArray } from '../utils/apiFetch';

const AllProductsContext = createContext();

export const useAllProductsContext = () => useContext(AllProductsContext);

export const AllProductsProvider = ({ children }) => {
    const [allProducts, setAllProducts] = useState([]);
    const [loadingAllProducts, setLoadingAllProducts] = useState(false);

    const fetchAllProducts = useCallback(async () => {
        if (allProducts.length > 0) return;
        setLoadingAllProducts(true);
        try {
          const response = await fetchJson('/api/product');
          const products = responseArray(response, 'products');
          setAllProducts(products);
        } catch (error) {
          console.error('Error:', error);
        } finally {
          setLoadingAllProducts(false);
        }
    }, [allProducts.length]);

    return (
        <AllProductsContext.Provider value={{ allProducts, setAllProducts, loadingAllProducts, setLoadingAllProducts, fetchAllProducts }}>
            {children}
        </AllProductsContext.Provider>
    );
};
